import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { getToken } from '../api/auth';
import { getSelectedCompanyId } from './selectedCompany';

export const API_URL = process.env.REACT_APP_API_URL || 'https://backend.chamafruits.com';

export const loadImageAsDataUrl = async (src) => {
  if (!src) return null;
  if (src.startsWith('data:image')) return src;

  try {
    const response = await fetch(src, { mode: 'cors', credentials: 'include' });
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const blob = await response.blob();
    return await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  } catch (err) {
    try {
      const proxyUrl = `${API_URL}/aws/proxy-image?url=${encodeURIComponent(src)}`;
      const token = getToken();
      const companyId = getSelectedCompanyId();
      const response = await fetch(proxyUrl, {
        credentials: 'include',
        headers: {
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
          ...(companyId ? { 'X-Company-Id': companyId } : {}),
        },
      });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const blob = await response.blob();
      return await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    } catch {
      return null;
    }
  }
};

export { jsPDF, autoTable };
